import { Theme } from "@components/theme/Theme";

import { StyledImage, StyledEyebrow, StyledText } from "./components";
import { BigCardProps } from "./types";

import styles from "./styles.module.css";

function WithBlueEyebrow(props: BigCardProps) {
  const { eyebrow } = props;

  return (
    <div className={styles.bigCardContainer}>
      <StyledImage {...props} />
      <div className={styles.bottom} data-skeleton-selector>
        {eyebrow && (
          <Theme accentColor="blue">
            <StyledEyebrow {...props} />
          </Theme>
        )}
        <StyledText {...props} />
      </div>
    </div>
  );
}

function WithFullBorderStyle(props: BigCardProps) {
  const { eyebrow } = props;

  return (
    <Theme borderStyle="full" radius="medium">
      <div
        className={styles.bigCardContainer}
        style={{ paddingBottom: "12px" }}
      >
        <StyledImage
          {...props}
          image={{
            ...props.image,
            style: {
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
            },
          }}
        />
        <div
          className={styles.bottom}
          style={{ paddingLeft: "12px" }}
          data-skeleton-selector
        >
          {eyebrow && <StyledEyebrow {...props} />}
          <StyledText {...props} />
        </div>
      </div>
    </Theme>
  );
}

function WithBlueEyebrowAndFullBorderStyle(props: BigCardProps) {
  const { eyebrow } = props;

  return (
    <Theme borderStyle="full" radius="medium">
      <div
        className={styles.bigCardContainer}
        style={{ paddingBottom: "12px" }}
      >
        <StyledImage
          {...props}
          image={{
            ...props.image,
            style: {
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
            },
          }}
        />
        <div
          className={styles.bottom}
          style={{ paddingLeft: "12px" }}
          data-skeleton-selector
        >
          {eyebrow && (
            <Theme accentColor="blue" borderStyle="none">
              <StyledEyebrow {...props} />
            </Theme>
          )}
          <StyledText {...props} />
        </div>
      </div>
    </Theme>
  );
}

export {
  WithBlueEyebrow,
  WithBlueEyebrowAndFullBorderStyle,
  WithFullBorderStyle,
};
